import { Chip } from '@mui/material';
import { Payment } from '@mui/icons-material';
import styles from '../../styles/scoped/user/ComingSoonFeatures.module.css';

export const ComingSoonFeatures = () => {
    return (
        <div className={styles.paymentBanner}>
            <div className={styles.bannerIcon}>
                <Payment />
            </div>
            <div className={styles.bannerContent}>
                <h4 className={styles.bannerTitle}>Paiements en ligne</h4>
                <p className={styles.bannerSubtitle}>
                    Règle tes contributions par carte bancaire ou Mobile Money
                </p>
            </div>
            <div className={styles.bannerActions}>
                <Chip
                    label="Bientôt disponible"
                    size="small"
                    className={styles.comingSoonChip}
                />
                <button className={styles.paymentButton} disabled>
                    Effectuer un paiement
                </button>
            </div>
        </div>
    );
};
